/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectRenterQuestions = (state: State) => state.renterQuestions.renterQuestions

export const selectRenterQuestionKeys = compose(
  (renterQuestions) => renterQuestions.map((renterQuestion) => renterQuestion.key),
  selectRenterQuestions
)
